/**
 * 首页
 * **/

const homeApi = {
  //首页统计
  getInfo: '/Project/GetGeneralInfo',

}

export default homeApi
